export enum enumPaymentProvider {
  PAYPAL,
  BLUESNAP,
  STRIPE,
  BANK,
}
